"use client";

import dynamic from "next/dynamic";

// ssr habilitado: el contenido del hero (títulos, CTAs, imagen LCP) debe ir en
// el HTML del servidor para que Google lo indexe y el LCP no espere al JS.
const HeroCarousel = dynamic(() => import("./HeroCarousel"), {
  loading: () => (
    <div className="h-[100svh] w-full animate-pulse bg-brand-950" />
  ),
});

export default function HeroCarouselLoader() {
  return <HeroCarousel />;
}
